/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NavigationLinkViewModelPrimeDatatableResults } from '../../models/navigation-link-view-model-prime-datatable-results';
import { PrimeDatatableParams } from '../../models/prime-datatable-params';

export interface ListNavigationLinks$Params {
      body?: PrimeDatatableParams
}

export function ListNavigationLinks(http: HttpClient, rootUrl: string, params?: ListNavigationLinks$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationLinkViewModelPrimeDatatableResults>> {
  const rb = new RequestBuilder(rootUrl, ListNavigationLinks.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NavigationLinkViewModelPrimeDatatableResults>;
    })
  );
}

ListNavigationLinks.PATH = '/api/Navigation/ListNavigationLinks';
